// ---- IMPORT COMPONENTS ----------------------------------- //
import React, { useContext } from "react";
// ---- COMPONENTS ----------------------------------- //
import Navbar from "../../components/general/Navbar";
import SplashScreen from "../../components/general/SplashInfo";
import ScrollTopBtn from "../../components/general/ScrollTopBtn";
// ---- IMPORT DATA ----------------------------------- //
import { GeneralContext } from "../../contexts/GeneralContext";
// ---- MAIN COMPONENTS ------------------------------- //
import About from "../about/About";
import Gallery from "../gallery/Gallery";
import Testimonial from "../Testimonials/Testimonial";
import Contact from "../contact/Contact";

import "./home.css";

const Home = ({ allStates, dispatch }) => {
  const [info] = useContext(GeneralContext);

  return (
    <div className="main">
      <Navbar />
      <SplashScreen {...info} />
      <About {...info} />
      <Gallery {...info} />
      <Testimonial {...info} />
      <Contact {...info} />
      <ScrollTopBtn />
    </div>
  );
};

export default Home;
